module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton8.44d842ef.jpg";